import { ref } from 'vue';
import { getAll } from "@/services/api/concessionaireService";

export function useConcessionaireSearch(initialParams = {}) {
  const searchQuery = ref("");
  const searchResults = ref([]);
  const isSearching = ref(false);
  let searchTimeout = null;

  const searchConcessionaires = async (customParams = {}) => {
    if (searchTimeout) clearTimeout(searchTimeout);

    if (!searchQuery.value || searchQuery.value.length < 3) {
      searchResults.value = [];
      return;
    }

    isSearching.value = true;

    searchTimeout = setTimeout(async () => {
      try {
        const params = { 
          search: searchQuery.value, 
          perPage: 10,
          ...initialParams,
          ...customParams 
        };
        
        const response = await getAll(params);
        // Normalizamos la respuesta por si la API cambia
        const results = response.data.data || response.data || [];
        searchResults.value = results;
        
      } catch (error) {
        console.error("Error en búsqueda:", error);
        searchResults.value = [];
      } finally {
        isSearching.value = false;
      }
    }, 400); // Debounce time
  };

  const clearSearch = () => {
    searchQuery.value = "";
    searchResults.value = [];
    if (searchTimeout) clearTimeout(searchTimeout);
  };

  return {
    searchQuery,
    searchResults,
    isSearching,
    searchConcessionaires,
    clearSearch
  };
}